<template>
    <div class="posts">
        <div class="inner">
            <h1>Teams</h1>
            <div v-if="loading" class="loading">Loading...</div>
            <div v-if="error" class="error">{{ error }}</div>
            <div v-if="teams" class="table">
                <table>
                    <thead>
                        <tr>
                            <th><small>Name</small></th>
                            <th><small>Logo</small></th>
                            <th><small>Players</small></th>
                            <th><small>Games played</small></th>
                            <th><small>Goals</small></th>
                            <th><small>Wins</small></th>
                        </tr>
                    </thead>
                    <tbody>
                        <TeamRow v-for="(item, index) in teams" v-bind:key="index" :item="item" />
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import TeamRow from '@/components/TeamRow.vue'
    
    export default {
        
        components: {
            TeamRow
        },
        
        data() {
            return {
                loading: false,
                error: null,
                teams: null,
                baseUrl: 'https://api.baserow.io'
            }
        },
        
        created() {
            this.fetchTournaments()
        },
        
        methods: {
            fetchTournaments() {
                this.error = null
                this.loading = true 
                
                // baserow.io Tournaments table fields
                // table ID 162682
                // field_1073613 date_start
                let url = new URL('/api/database/rows/table/162682/?user_field_names=true&order_by=name&page=1&size=100', this.baseUrl);
                //console.log('url.href', url.href);

                // Request() constructor
                const headers = new Headers({
                    Authorization: "Token ElvFpuln7uKKxkC7C34WnKY4Z5RdA1ND"
                });
                const request = new Request(url.href, {
                    method: "GET",
                    headers: headers,
                    mode: "cors",
                    cache: "default"
                });
                fetch(request)
                    .then((response) => {
                        if (response.status === 200) {
                            return response.json();
                        } else {
                            throw new Error("Something went wrong on API server!");
                        }
                    })
                    .then((data) => {
                        console.log(data.results);
                        this.loading = false;
                        this.teams = data.results
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                
            }
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>